import { IEquipment, IEquipmentPassport } from '@/pages/Equipment/equipment.types.ts'
import equipmentUtils from '@/pages/Equipment/equipment.utils.ts'
import useEquipmentForm from '@/pages/Equipment/components/SidePages/EquipmentFormFields/hooks/useEquipmentForm.ts'
import SeparateLine from '@/shared/Forms/SeparateLine'
import DropdownListItem from '@/shared/Dropdowns/DropdownListItem'
import EquipmentPassportTree from '@/pages/Equipment/components/SidePages/EquipmentFormFields/EquipmentPassportTree'
import Button from '@/shared/Buttons/Button'
import useHttpLoader from '@/shared/hooks/useHttpLoader.ts'
import EquipmentFormFields from '@/pages/Equipment/components/SidePages/EquipmentFormFields'
import EquipmentPassportValuesForm from '@/pages/Equipment/components/SidePages/EquipmentFormFields/EquipmentPassportValuesForm'
import equipmentApi from '@/pages/Equipment/equipment.api.ts'
import equipmentEvents from '@/pages/Equipment/events/equipment/equipment.events.ts'

interface IProps {
  passport: IEquipmentPassport
  equipment: IEquipment
  onCancel: () => void
}

const EquipmentSidePageEditContent = (props: IProps) => {
  const { wait, loading } = useHttpLoader()

  const ctrl = useEquipmentForm({
    passport: equipmentUtils.passportInstanceToPassportDTO(props.passport) || { passportSchemaId: null, values: [] },
    equipment: equipmentUtils.equipmentToDto(props.equipment),
  })

  const handleSave = () => {
    const job = async () => {
      const resp = await equipmentApi.updateEquipment(props.equipment.id, ctrl.equipment)
      if (resp.status === 'success') {
        const passportResp = await equipmentApi.putEquipmentPassport(resp.body.id, ctrl.passport)
        if (passportResp.status === 'success') {
          return { ...resp, body: { ...resp.body, passportInstanceId: passportResp.body.id } }
        }
      }

      return resp
    }

    wait(job(), (resp) => {
      if (resp.status === 'success') {
        equipmentEvents.updated(resp.body)
        props.onCancel()
      }
    })
  }

  const renderContent = () => {
    if (ctrl.selectedTab === 'main') {
      return (
        <EquipmentFormFields
          equipment={ctrl.equipment}
          onChange={ctrl.handleEquipmentChange}
          passportSchemaId={ctrl.passport.passportSchemaId}
          onPassportSchemaChange={ctrl.handlePassportSchemaSelect}
        />
      )
    }
    if (ctrl.selectedTab === 'passport') {
      return (
        <EquipmentPassportValuesForm
          passportSchemaId={ctrl.passport.passportSchemaId}
          onChange={ctrl.handlePassportValueUpdate}
          values={ctrl.passport.values}
        />
      )
    }
  }

  return (
    <div className="flex-lines height100 gap16" style={{ scrollBehavior: 'smooth' }}>
      <h4 className="text-heading-4">Редактирование устройства</h4>
      <SeparateLine />
      <div className="inline-flex-gap gap16 height100" style={{ minHeight: 0 }}>
        <div
          className="flex-lines gap8 height100"
          style={{
            width: '280px',
            borderRight: '1px solid var(--border-secondary-color)',
            paddingRight: '12px',
            minHeight: 0,
          }}
        >
          <DropdownListItem active={ctrl.selectedTab === 'main'} onClick={() => ctrl.handleTabSelect('main')}>
            <span className="text-nm" style={{ color: 'inherit' }}>
              Общие данные
            </span>
          </DropdownListItem>
          <SeparateLine />
          <span className="text-sm text-description" style={{ marginLeft: '12px' }}>
            Паспорт лифта
          </span>
          <EquipmentPassportTree
            passportSchemaId={ctrl.passport.passportSchemaId}
            selectCtrl={{ ...ctrl.groupSelectCtrl, handleSelect: ctrl.handlePassportGroupSelect } as any}
          />
        </div>
        <div
          className="flex-lines gap16 width100"
          style={{
            overflow: 'auto',
            paddingRight: '24px',
            height: '100%',
            minHeight: 0,
            paddingLeft: '2px',
            scrollBehavior: 'smooth',
          }}
        >
          {renderContent()}
        </div>
      </div>
      <div style={{ marginTop: 'auto' }}>
        <SeparateLine />
      </div>
      <div className="inline-flex-gap" style={{ paddingBottom: '20px' }}>
        <Button size="default" type="primary" text="Сохранить" loading={loading} onClick={handleSave} />
        <Button size="default" type="default" text="Отменить" disabled={loading} onClick={props.onCancel} />
      </div>
    </div>
  )
}

export default EquipmentSidePageEditContent
